import { computed } from 'vue'
import useAuthStore from '@/store/auth.store'

export default function usePermissions() {
  const store = useAuthStore()
  const isAdmin = computed(() => store.isAdmin)
  return { isAdmin }
}
